<template>
<p class="label"><slot /></p>
</template>
<script>
export default {
  name: "bk-input-label",
  props: {
    /**
     * The Label of this component
     */
    label: String,
  },
}
</script>
<style lang="scss" scoped>
  .label {
    padding-top: 16px;
    margin-bottom: 5px !important;
    font-weight: bold;
  }
</style>
